import { ScoreChartValues } from "src/components/ScoreChart/ScoreChart";
import { ScoreDimension, ScoreDimensionValue } from "src/api/client-api/post/scoreSchema";
import { ChartDataItem, ScoreVariationUI } from "../types";

export const extractHeadingData = (heading: ScoreDimensionValue): ChartDataItem => {
    const dimensionValue = heading;
    return {
        value: Number(dimensionValue.score || 0),
        label: dimensionValue.label || "",
    };
};

export const formatChartData = (headings: Partial<ScoreDimension>): ScoreChartValues => {
    const valuesObj = headings.values || {};
    const values = Object.values(valuesObj).map(extractHeadingData);

    return {
        values: values.map((item) => item.value),
        labels: values.map((item) => item.label),
    };
};

export const extractDimensions = (scoreData: Record<string, unknown> | undefined): string[] => {
    if (!scoreData || !scoreData.dimensions) {
        return [];
    }

    return Array.isArray(scoreData.dimensions) ? Object.keys(scoreData.dimensions).map((key) => String(key)) : [];
};

export const createScoreEntity = (
    selectedScore: Record<string, unknown> | undefined,
    scoreUnit: string | undefined,
    effectiveVariationId: number | string | null,
    dimensions: string[],
): ScoreVariationUI => {
    const id = selectedScore?.id ? Number(selectedScore.id) : 0;
    const label = typeof selectedScore?.label === "string" ? selectedScore.label : "";
    const unit = scoreUnit || "";
    const precision = selectedScore?.precision ? Number(selectedScore.precision) : 0;
    const variationId = effectiveVariationId ? Number(effectiveVariationId) : null;

    return {
        id,
        label,
        unit,
        precision,
        scoreId: id,
        variationId,
        dimensions,
    };
};
